var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"empty-toolbar-to-fix-quill-smart-paste-bug"}),_c('vue-editor',{attrs:{"placeholder":"Add a note. Use @mentions to notify a teammate.","editor-options":_vm.editorSettings},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }